import WishlistQuery from 'Query/Wishlist.query';
import {
    CartDispatcher as SourceCartDispatcher,
    isWishlistEnabled as SourceIsWishlistEnabled,
    WishlistDispatcher as SourceWishlistDispatcher
} from 'SourceStore/Wishlist/Wishlist.dispatcher';
import { showNotification } from 'Store/Notification/Notification.action';
import { updateIsLoading } from 'Store/Wishlist/Wishlist.action';
import { isSignedIn } from 'Util/Auth';
import { fetchMutation } from 'Util/Request';
// TODO: implement CartDispatcher
export const CartDispatcher = SourceCartDispatcher;

// TODO: implement isWishlistEnabled
export const isWishlistEnabled = SourceIsWishlistEnabled;

/** @namespace Pwa/Store/Wishlist/Dispatcher/WishlistDispatcher */
export class WishlistDispatcher extends SourceWishlistDispatcher {
    // TODO implement logic

    addBundleProductToWishlist(dispatch, data) {
        if (!isSignedIn()) {
            return Promise.reject();
        }

        dispatch(updateIsLoading(true));

        return fetchMutation(WishlistQuery.getAddProductsToWishlist(data)).then(
            /** @namespace Pwa/Store/Wishlist/Dispatcher/fetchMutation/then */
            () => {
                dispatch(showNotification('success', __('Product added to wish-list!')));
                this._syncWishlistWithBE(dispatch);
            },
            /** @namespace Pwa/Store/Wishlist/Dispatcher/fetchMutation/then */
            () => {
                dispatch(showNotification('error', __('Error updating wish list!')));
            }
        );
    }

    addItemToWishlist(dispatch, wishlistItem) {
        if (!isSignedIn()) {
            return Promise.reject();
        }

        dispatch(updateIsLoading(true));

        return fetchMutation(WishlistQuery.getSaveWishlistItemMutation(wishlistItem)).then(
            /** @namespace Pwa/Store/Wishlist/Dispatcher/fetchMutation/then */
            () => {
                dispatch(showNotification('success', __('Product added to wish-list!')));
                this._syncWishlistWithBE(dispatch);
            },
            /** @namespace Pwa/Store/Wishlist/Dispatcher/fetchMutation/then */
            () => {
                dispatch(showNotification('error', __('Error updating wish list!')));
            }
        );
    }
}

export default new WishlistDispatcher();
